import React from 'react';
import './text-input.css';

import SimpleInput from './SimpleInput';

class TextInput extends React.Component {
  constructor (props){
    super(props);
    this.state = {...props};
  }

  render(){
    //console.log(this.state);
    //console.log(this.props);
    //console.log('**********');
    const checkReadOnly = this.props.readOnly ? 'box-input-read-only' : '';
    return(
      <div className={`${checkReadOnly} box-input`}>
          <div className="box-input--title">{this.props.title}</div>
          <div className="box-input--border">
            <div className="box-input--inner">
              <SimpleInput
                onChange={this.props.onChange}
                placeholder={this.props.placeholder}
                value={this.props.value}
                name={this.props.name}
                type={this.props.type}
                readOnly={this.props.readOnly}
              />
            </div>
          </div>
      </div>
    )
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/form/TextInput.js